import { defineComponent } from 'vue';
import { ElMenuItem, ElSubMenu } from 'element-plus';
export default defineComponent({
    name: 'SubmenuListPc',
    components: {
        'el-menu-item': ElMenuItem,
        'el-sub-menu': ElSubMenu
    },
    props: {
        data: {
            type: Object,
            default: ()=>{}
        },
        index: {
            type: String,
            default: null
        }
    },
    setup () {
        const jumpMenu = (link)=>{
            link && window.history.pushState({}, '', link);
        };
        return {
            jumpMenu
        };
    }
});
